// Styles
import './template-cart.scss';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initTemplateCart = (context) => {
  const templateCartSection = context.closest('.shopify-section');
  if (!templateCartSection) return;

  var $form = $(templateCartSection).find('#cart-form');
  if ($form.length <= 0) return;

  $form.find('[type="submit"][name="update"]').on('mousedown', function () {
    $form.off('submit.Parsley');
  });

  const updateCartPage = () => {
    $(context).addClass('is-loading');
    $.post(window.Shopify.routes.root + 'cart/update.js', $form.serialize(), (data) => {
      if (data.items.length <= 0) {
        location.reload();
      } else {
        var selectorToRemove = '.cart__form__row--product';
        data.items.forEach(lineItem => {
          const $el = $form.find('#line-item--' + lineItem.id);
          if ($el.length > 0) {
            const $priceLabel = $el.find('[data-original-price]');
            if ($priceLabel.length > 0) {
              $priceLabel.text(theme.Currency.formatMoney(lineItem.original_line_price, theme.strings.moneyFormat));
            }

            const $qty = $el.find('.js-qty');
            if ($qty.length > 0) {
              const $label = $qty.find('.js-qty__num');
              if ($label.length) {
                $label.val(lineItem.quantity);
              }

              const $removeButton = $qty.find('.js-qty__adjust--minus');
              if (lineItem.quantity <= 1) {
                $removeButton.attr('disabled', '');
              }
            }
          }
          selectorToRemove += ':not(#line-item--' + lineItem.id + ')';
        });
        const $totalPrice = $form.find('[data-total-price]');
        if ($totalPrice.length > 0) {
          $totalPrice.text(theme.Currency.formatMoney(data.total_price, theme.strings.moneyFormat));
        }
        const $toRemove = $form.find(selectorToRemove);
        if ($toRemove.length > 0) {
          $toRemove.remove();
        }

        const $checkoutButton = $form.find('.cart__checkout');
        if ($checkoutButton.length > 0) {
          if (data.currency == 'GBP' && data.total_price < 13500) {
            $checkoutButton.addClass('trigger-alert-popup')
          } else {
            $checkoutButton.removeClass('trigger-alert-popup')
          }
        }
      }
      $(context).removeClass('is-loading');
    }, 'json')
      .catch(err => {
        console.log('$.post() error:', err);
      });
  };

  $form.find('.cart__form__meta__remove a').on('click', function (e) {
    e.preventDefault();

    $(this).closest('.cart__form__row').find('.js-qty__num').val(0);
    updateCartPage();
  });

  const initNumberInputs = () => {
    $form.find('.js-qty button').on('click', function () {
      const $qtyContainer = $(this).closest('.cart__form__row__element--quantity');
      if ($qtyContainer.data().stock) {
        const stock = parseInt($qtyContainer.data().stock);
        const $value = $(this).closest('.js-qty').find('.js-qty__num');
        const $addButton = $(this).closest('.js-qty').find('.js-qty__adjust--plus');

        if (stock <= parseInt($value.val())) {
          $addButton.attr('disabled', '');
        } else {
          $addButton.removeAttr('disabled', '');
        }
      }

      updateCartPage();
    });

    $form.find('.cart__form__row--product .cart__form__row__element--quantity').each(function () {
      const $value = $(this).find('.js-qty__num');
      const $addButton = $(this).find('.js-qty__adjust--plus');

      if ($(this).data().stock && $addButton.length > 0) {
        const stock = parseInt($(this).data().stock);

        if (stock < parseInt($value.val())) {
          $value.val(stock);
          updateCartPage();
        }

        if (stock == parseInt($value.val())) {
          $addButton.attr('disabled', '');
        }
      }

      const $removeButton = $(this).find('.js-qty__adjust--minus');
      if ($removeButton.length > 0 && parseInt($value.val()) <= 1) {
        $removeButton.attr('disabled', '');
      }

      $(this).removeClass('hidden-before-js');
    });
  }

  if (typeof (window.dAgency.initNumberInputs) !== 'undefined' && window.dAgency.initNumberInputs) {
    initNumberInputs();
  } else {
    $(document).on('InitializedNumberInputs', function () {
      initNumberInputs();
    });
  }
}

if (document.readyState != "loading") {
  [].forEach.call(document.querySelectorAll('.cart-section'), (el) => {
    window.dAgency.initTemplateCart(el);
  });
} else {
  document.addEventListener('DOMContentLoaded', () => {
    [].forEach.call(document.querySelectorAll('.cart-section'), (el) => {
      window.dAgency.initTemplateCart(el);
    });
  });
}
